var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocColoredIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.35 5.142L9.852 1.646l-.015-.014-.02-.018-.015-.011c-.008-.006-.016-.013-.025-.018l-.012-.008a.51.51 0 00-.03-.018l-.009-.004a.486.486 0 00-.035-.017l-.006-.002a.49.49 0 00-.04-.014L9.64 1.52a.497.497 0 00-.042-.01l-.013-.002-.035-.005A.496.496 0 009.5 1.5h-6a1.001 1.001 0 00-1 1v11a1.001 1.001 0 001 1h9a1.001 1.001 0 001-1V5.51 5.5a.499.499 0 00-.15-.358zM10 11H6a.5.5 0 010-1h4a.5.5 0 110 1zm0-2H6a.5.5 0 010-1h4a.5.5 0 110 1zm-.5-3.5V2.707L12.293 5.5H9.5z",
    fill: "#33647E"
  })));
}
export default SvgDocColoredIcon;